module.exports = __webpack_public_path__ + "img/chart-mobile.fa6b3980.png";